export type RecordSgm = {
  name: string,
  rows: Array<any>,
  category: string,
  key: string,
  type: 'download' | 'form' | 'pending',
}

export default {
  anexos: [
    {
      key: 'anexo-2',
      name: 'ANEXO 2. POLÍTICA DEL SGM',
      rows: [],
      type: 'download',
      category: 'anexos',
    },
    {
      key: 'anexo-3',
      name: 'ANEXO 3. GUÍA PARA LA ELABORACIÓN DE DOCUMENTOS',
      type: 'download',
      rows: [],
      category: 'anexos',

    },
    {
      key: 'anexo-4',
      name: 'ANEXO 4. PLAN DE ATENCIÓN A EMERGENCIAS',
      rows: [],
      type: 'form',
      category: 'anexos',
    },
    {
      key: 'anexo-5',
      name: 'ANEXO 5. RESPONSABILIDADES DE LAS BRIGADAS',
      rows: [],
      type: 'download',
      category: 'anexos',
    },
    {
      key: 'anexo-6',
      name: 'ANEXO 6. DIRECTORIO DE EMERGENCIAS',
      rows: [],
      type: 'form',
      category: 'anexos',
    },
    {
      key: 'anexo-10',
      name: 'ANEXO 10. REGISTRO DE EVENTOS CLASIFICADOS Y NO CLASIFICADOS DEL PROGRAMA INFORMATICO',
      rows: [],
      type: 'form',
      category: 'anexos',
    },
  ] as RecordSgm[],
  formatos: [
    {
      key: 'formato-1',
      name: 'FOR-SGMES-EMP-001 - FORMATO DE CONFIDENCIALIDAD DE LOS DOCUMENTOS DEL SISTEMA DE GESTIÓN DE MEDICIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-2',
      name: 'FOR-SGMES-EMP-002 - FORMATO LISTA MAESTRA DE CONTROL DE DOCUMENTOS Y REGISTROS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-3',
      name: 'FOR-SGMES-EMP-003 - FORMATO DE CONTROL DE DISTRIBUCIÓN DE DOCUMENTOS Y REGISTROS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-4',
      name: 'FOR-SGMES-EMP-004 - FORMATO PARA PROGRAMA DE REVISIÓN DE LA DOCUMENTACIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-5',
      name: 'FOR-SGMES-EMP-005 - FORMATO DE CONTROL DE DIFUSION DE DOCUMENTOS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-6',
      name: 'FOR-SGMES-EMP-006 - FORMATO DE CONTROL DE RETIRO DE DOCUMENTOS OBSOLETOS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-7',
      name: 'FOR-SGMES-EMP-007 - FORMATO DE DESIGNACIÓN DE LA FUNCIÓN METROLÓGICA',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-8',
      name: 'FOR-SGMES-EMP-008 - PROGRAMA DE REVISIONES POR LA DIRECCIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-9',
      name: 'FOR-SGMES-EMP-009 - MINUTA DE REVISIONES POR LA DIRECCIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-10',
      name: 'FOR-SGMES-EMP-010 - FORMATO DE DESCRIPCIÓN DE PUESTOS DE TRABAJO',
      rows: [],
      type: 'download',
      category: 'formatos',
    },
    {
      key: 'formato-11',
      name: 'FOR-SGMES-EMP-011 - LISTA DE ASISTENCIA',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-12',
      name: 'FOR-SGMES-EMP-0012 - PROGRAMA ANUAL DE CAPACITACIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-13',
      name: 'FOR-SGMES-EMP-0013 - FORMATO DE REPORTE DE ACCIÓNES CORRECTIVAS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-14',
      name: 'FOR-SGMES-EMP-0014 - FICHA TÉCNICA DE EQUIPOS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-15',
      name: 'FOR-SGMES-EMP-0015 - FORMATO DE REPORTE DE ACCIONES PREVENTIVAS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-16',
      name: 'FOR-SGMES-EMP-016 - PROGRAMA DE AUDITORÍAS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-17',
      name: 'FOR-SGMES-EMP-017 - PLAN DE AUDITORIAS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-18',
      name: 'FOR-SGMES-EMP-018 - FORMATO DE HALLAZGO DE AUDITORÍA',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-19',
      name: 'FOR-SGMES-EMP-019 - FORMATO DE REVISIÓN DE ACCIONES CORRECTIVAS Y PREVENTIVAS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-20',
      name: 'FOR-SGMES-EMP-020 - FORMATO DE DETECCIÓN DE NECESIDADES DE CAPACITACIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-21',
      name: 'FOR-SGMES-EMP-021 - FORMATO DE EVALUACIÓN INDIVIDUAL DE CURSOS Y CAPACITACIONES',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-22',
      name: 'FOR-SGMES-EMP-022 - AVISO DE CONFORMACIÓN DEL EQUIPO AUDITOR',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-23',
      name: 'FOR-SGMES-EMP-023 - REQUISICIÓN DE MATERIAL O SERVICIO',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-24',
      name: 'FOR-SGMES-EMP-024 - FORMATO PARA LA EVALUACIÓN DE PROVEEDORES ',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-25',
      name: 'FOR-SGMES-EMP-025 - FORMATO DE VERIFICACIÓN DE PRODUCTOS O SERVICIOS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-26',
      name: 'FOR-SGMES-EMP-026 - REGISTRO DE QUEJAS',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-27',
      name: 'FOR-SGMES-EMP-027 - SISTEMA DE GESTIÓN DE RIESGOS DEL SGM',
      rows: [],
      type: 'download',
      category: 'formatos',
    },
    {
      key: 'formato-28',
      name: 'FOR-SGMES-EMP-028 - FORMATO DE TOMA DE LECTURAS CON CINTA PETROLERA',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-29',
      name: 'FOR-SGMES-XXX-029 - FORMATO DE CALCULO DE PRESUPUESTO DE INCERTIDUMBRE DE LA MEDICION',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-30',
      name: 'FOR-SGMES-XXX-030 - HOJA DE BALANCE VOLUMETRICO',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-31',
      name: 'FOR-SGMES-XXX-031 - LISTA DE EQUIPOS CRÍTICOS DEL SISTEMA DE MEDICIÓN',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
    {
      key: 'formato-32',
      name: 'FOR-SGMES-XXX-032 - PROGRAMA ANUAL DE CALIBRACION A EQUIPOS DE MEDICION DEL SGM',
      rows: [],
      type: 'form',
      category: 'formatos',
    },
  ] as RecordSgm[],
  manual: [
    {
      key: 'manual-1',
      name: 'MAN-SGMES-EMP-001 - MANUAL DEL SISTEMA DE GESTIÓN DE MEDICIONES',
      rows: [],
      type: 'form',
      category: 'manual',
    }
  ] as RecordSgm[],
  procedimientos: [
    {
      key: 'procedimiento-1',
      name: 'PRO-SGMES-EMP-001 - PROCEDIMIENTO PARA EL CONTROL DE DOCUMENTOS Y REGISTROS',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-2',
      name: 'PRO-SGMES-EMP-002 - PROCEDIMIENTO PARA LA REALIZACIÓN DE AUDITORÍAS',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-3',
      name: 'PRO-SGMES-EMP-003 - PROCEDIMIENTO PARA LAS REVISIONES POR LA DIRECCIÓN',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-4',
      name: 'PRO-SGMES-EMP-004 - PROCEDIMIENTO DE CAPACITACIÓN DEL PERSONAL',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-5',
      name: 'PRO-SGMES-EMP-005 - PROCEDIMIENTO PARA LOS EQUIPOS DE MEDICIÓN',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-6',
      name: 'PRO-SGMES-EMP-006 - PROCEDIMIENTO PARA LA EVALUACIÓN DE PROVEEDORES',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-7',
      name: 'PRO-SGMES-EMP-007 - PROCEDIMIENTO PARA ACCIONES PREVENTIVAS Y DE MEJORA EN EL SISTEMA DE GESTIÓN DE MEDICIÓN',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-8',
      name: 'PRO-SGMES-EMP-008 - PROCEDIMIENTO PARA ACCIONES CORRECTIVAS',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-9',
      name: 'PRO-SGMES-EMP-009 - PROCEDIMIENTO PARA LA CONFIRMACIÓN METROLÓGICA',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-10',
      name: 'PRO-SGMES-EMP-010 - PROCEDIMIENTO PARA LA ATENCIÓN DE QUEJAS',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-11',
      name: 'PRO-SGMES-EMP-011 - PROCEDIMIENTO PARA LA IDENTIFICACIÓN Y EL CONTROL DE RIESGOS',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-12',
      name: 'PRO-SGMES-EMP-012 - PROCEDIMIENTO DE PREPARACIÓN Y RESPUESTA A EMERGENCIAS',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-13',
      name: 'PRO-SGMES-EMP-013 - PROCEDIMIENTO PARA LA ESTIMACIÓN DE LA INCERTIDUMBRE',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-14',
      name: 'PRO-SGMES-EMP-014 - PROCEDIMIENTO PARA LA MEDICIÓN DE NIVEL EN TANQUES DE ALMACENAMIENTO',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
    {
      key: 'procedimiento-15',
      name: 'PRO-SGMES-XXX-015 - PROCEDIMIENTO DE BALANCE VOLUMETRICO Y DESVIO DE PRODUCTO',
      rows: [],
      type: 'form',
      category: 'procedimientos',
    },
  ] as RecordSgm[]
}